export const SET_USER_PAYMENTS = 'SET_USER_PAYMENTS';

export const setUserPayments = payments => ({
  type: SET_USER_PAYMENTS,
  payload: payments,
});
